const actionToAuthType = {
  // browser
  browser_auto: 'browser',
  raw_browser_auto: 'browser',
  short_browser_auto_playwright: 'browser',
  long_browser_auto_playwright: 'browser',
  ai_browser_auto_playwright: 'browser',
  short_ai_browser_auto_playwright: 'browser',
  browser_auto_webdriver_js: 'browser',

  // database
  execute_raw_query: 'database',

  // dynamic
  integration_store: 'dynamic',

  // aws
  aws_s3_upload: 'aws',
  aws_s3_download: 'aws',
  aws_send_sqs: 'aws',
  aws_ses_send_email: 'aws',

  // apiToken
  execute_http_request: 'apiToken',

  // sftp
  sftp_upload: 'sftp',
  sftp_download: 'sftp',

  // google
  google_drive_upload_file: 'google',
  google_drive_download_file: 'google',
  google_get_folder: 'google',
  google_search_in_drive: 'google',
  google_sheets_read_data: 'google',
  google_sheets_write_data: 'google',
  google_gmail_send_email: 'google',
  google_gmail_read_email: 'google',
  incoming_event_google_drive: 'google',

  // outlook
  msgraph_onedrive_upload_file: 'outlook',
  msgraph_onedrive_download_file: 'outlook',
  msgraph_file_access: 'outlook',
  msgraph_workbook_read_data: 'outlook',
  msgraph_workbook_write_data: 'outlook',
  msgraph_mail_send_email: 'outlook',
  msgraph_mail_read_email: 'outlook',
  msgraph_onedrive_create_folder: 'outlook',
  msgraph_onedrive_get_folder: 'outlook',
  msgraph_onedrive_move_file: 'outlook',
  msgraph_workbook_update_cell: 'outlook',
  incoming_event_onedrive: 'outlook',

  // action with pdf lib and outlook api
  js_large_pdf: 'outlook',

  // pVerify
  get_benefits_pverify: 'pVerify',
  get_benefits_batch_pverify: 'pVerify',
  get_benefits_batch_pverify_from_file: 'pVerify',
  eligibiltiy_pdf_report_pverify: 'pVerify',
  parse_benefits_pverify: 'pVerify',
  get_inquiry_pverify: 'pVerify',

  // twilio
  twilio_send_sms: 'twilio',
  twilio_list_sms: 'twilio',
  twilio_send_email: 'twilio',

  // externalWorkflowActivator
  task_update_patient_insurance: 'externalWorkflowActivator',

  // podium
  podium_read_message: 'podium',
  podium_send_message: 'podium',
};

export const getAuthTypeForAction = (actionType) => {
  return actionToAuthType[actionType];
};
